import {getTodayStartTime} from 'shared/utils/dateTime';
import {saveState} from 'interactors/statePersistence';

type StatePreserver = (settings: StorableState) => void;

export function refreshState(
  newSettings: CoreState,
  saveSettings: StatePreserver = saveState
): void {
  const lastRecalcDateTime = getTodayStartTime();
  saveSettings({...newSettings, lastRecalcDateTime});
}
